<template>
    <div ref="ai-help-modal" class="app-modal-dialog app-modal-dialog--ai-help modal fade" tabindex="-1" role="dialog">
        <div class="app-modal-dialog__content" role="document">
            <div class="app-modal-dialog__header">
                <h2 class="app-modal-dialog__title">{{ title }}</h2>
                <button type="button" class="element-button--icon element-button" data-dismiss="modal" aria-label="Close">
                    <svg class="element-icon--x element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-x"></use></svg>
                </button>
            </div>
            <div class="app-modal-dialog__body">{{content}}</div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        settings: {
            type: Object,
            default: {}
        },
        settingAlias: {
            type: String
        },
        title: {
            type: String,
            default: 'AI Help'
        }
    },
    computed: {
        content () {
            if(this.settings && this.settings[this.settingAlias])
                return this.settings[this.settingAlias]
            else
                return "N/A";
        },
    }
}
</script>
